import { render, staticRenderFns } from "./deleteAll.vue?vue&type=template&id=71db3746&"
import script from "./deleteAll.vue?vue&type=script&lang=ts&"
export * from "./deleteAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports